// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandAndTypeModale_container__2NMXB","buttons":"BrandAndTypeModale_buttons__2zWWu","title":"BrandAndTypeModale_title__3OE_w"};